import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import classes from './style.module.scss';
import facebook from '@/components/common/icons/facebook.svg';
import instagram from '@/components/common/icons/instagram.svg';
import linkClientBackground from '@/components/common/icons/linkClientBackground.svg';
import linkedin from '@/components/common/icons/linkedin.svg';
import youtube from '@/components/common/icons/youtube.svg';
import linkClientImage from '@/png-icons/linkClientImage.png';

const DEFAULT_SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/somosgruporv/',
  facebook: 'https://www.facebook.com/somosgruporv',
};

const PORTUGAL_SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/redevistorias_portugal',
  facebook: 'https://www.facebook.com/people/Rede-Vistorias-Portugal/61556151788441/',
};

const ClientLinkLayoutComponent = ({ children, franchise, masks, addressService, isBrazilianFranchisee, franchiseeCountry }) => {
  const intl = useIntl();
  const socialLinks = franchiseeCountry === 'PT' ? PORTUGAL_SOCIAL_LINKS : DEFAULT_SOCIAL_LINKS;
  
  return (
    <div className={classes.ClientLinkLayout}>
      <div className={classes.header}>
        <div className={classes.container}>
          <div className={classes.logo}>
            <img src="/assets/img/rv-logo.png" alt="Logo Rede Vistorias" />
          </div>
          <div className={classes.headerRigth}>
            <h6>{franchise?.name}</h6>
            <p>{franchise?.email}</p>
            <p>{franchise?.phone}</p>
          </div>
        </div>
      </div>
      <div className={classes.Content} style={{ backgroundImage: `url(${linkClientBackground})` }}>
        <div className={classes.ContentLeft}>
          <div>
            <h3>{intl.formatMessage({ id: 'CLIENT_LINK.REGISTER_TITLE' })}</h3>
            <p>{intl.formatMessage({ id: 'CLIENT_LINK.REGISTER_DESCRIPTION' })}</p>
            <img className={classes.Image} src={linkClientImage} alt=""></img>
          </div>
        </div>
        <div className={classes.ContentRight}>{children}</div>
      </div>
      <div className={classes.Footer}>
        <div className={classes.FooterLeft}>
          <img src="/assets/img/rv-group-logo.jpg" alt="Logo Rede Vistorias" />
          <p>
            {intl.formatMessage({ id: 'CLIENT_LINK.ADDRESS_TEXT' })}
          </p>
        </div>
        <div className={classes.FooterRight}>
          <p>{intl.formatMessage({ id: 'CLIENT_LINK.SOCIAL_TEXT' })}</p>
          <ul className={classes.social}>
            <li>
              <a href="https://www.youtube.com/c/SomosGrupoRV" target="_blank" rel="noreferrer">
                <img src={youtube} alt="youtube" />
              </a>
            </li>
            <li>
              <a href={socialLinks.instagram} target="_blank" rel="noreferrer">
                <img src={instagram} alt="instagram" />
              </a>
            </li>
            <li>
              <a href={socialLinks.facebook} target="_blank" rel="noreferrer">
                <img src={facebook} alt="facebook" />
              </a>
            </li>
            <li>
              <a href="https://br.linkedin.com/company/somosgruporv" target="_blank" rel="noreferrer">
                <img src={linkedin} alt="linkedin" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={classes.Footerbar}>
        <div>{intl.formatMessage({ id: 'CLIENT_LINK.COPYRIGHT' }, { year: new Date().getFullYear() })}</div>
        <div>{intl.formatMessage({ id: 'CLIENT_LINK.CNPJ' })}</div>
        <div>{intl.formatMessage({ id: 'CLIENT_LINK.DEVELOPED_BY' })}</div>
      </div>
    </div>
  );
};

ClientLinkLayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
  franchise: PropTypes.object,
  masks: PropTypes.object,
  addressService: PropTypes.object,
  isBrazilianFranchisee: PropTypes.bool,
  franchiseeCountry: PropTypes.string,
};

ClientLinkLayoutComponent.defaultProps = {
  franchise: null,
  masks: null,
  addressService: null,
  isBrazilianFranchisee: true,
  franchiseeCountry: 'BR',
};

export default ClientLinkLayoutComponent;
